import { CitySearchResult } from '@models/address.model';

export function getCityDescription(city: CitySearchResult): string {
  return city?.Present;
}
